// import "./zoom-gallery";

class MediaGallery extends HTMLElement {
  constructor() {
    super();

    this.activeVideos = [];

    window.loadSwiper.then((swiper) => {
      this.swiperLib = swiper;
      this._initThumbsCarousel();
      this._initCarousel();
    });
  }

  connectedCallback() {
    document.addEventListener("click", (e) => {
      if (!this.contains(e.target)) {
        document.body.classList.remove("no-scroll");

        if (this.gallerySwiper.slides.length) {
          this.gallerySwiper.zoom.out();
        }
      }
    });

    this.addEventListener("click", (e) => {
      if (e.target.closest("[data-video-control-button]")) return;

      const zoomButton = e.target.closest("[data-open-zoom]");
      if (zoomButton) {
        this._openZoomGallery(zoomButton);
      }
    });

    this.addEventListener("keyup", (e) => {
      if (
        !("thumbnailIndex" in e.target.dataset) ||
        (e.key !== "Enter" && e.key !== " ")
      )
        return;

      const index = parseInt(e.target.dataset.thumbnailIndex);

      this.gallerySwiper?.slideToLoop(index, 400);
    });
  }

  disconnectedCallback() {}

  _initThumbsCarousel() {
    if (this.thumbsSwiper) return;

    const container = this.querySelector(
      `.${this._prefix}__thumbnails-container`,
    );

    if (!container) return;

    const { Swiper, Thumbs, Mousewheel } = this.swiperLib;

    this._toggleSwiperClasses(true);

    const swiperParams = {
      modules: [Thumbs, Mousewheel],
      slidesPerView: "auto",
      cssMode: true,
      direction: "vertical",
      watchSlidesProgress: true,
      mousewheel: true,
    };

    this.thumbsSwiper = new Swiper(container, swiperParams);

    this.thumbsSwiper.on("click", () => {
      this.dispatchEvent(
        new CustomEvent("cylindo-trigger", {
          bubbles: true,
          detail: { action: null },
        }),
      );
    });
  }

  _initCarousel() {
    const { Swiper, Pagination } = this.swiperLib;

    if (this.gallerySwiper) return;

    this._toggleSwiperClasses(true);

    const updateCurrentSlide = () => {
      if (!this.thumbsSwiper || !this.gallerySwiper) return;

      const activeThumb =
        this.thumbsSwiper.slides[this.gallerySwiper.realIndex];

      const activeSlide =
        this.gallerySwiper.slides[this.gallerySwiper.realIndex];

      this.thumbsSwiper.slides.forEach((slide) => {
        const button = slide.querySelector("button");
        if (slide === activeThumb) {
          button.setAttribute("aria-current", "true");
        } else {
          button.removeAttribute("aria-current");
        }
      });

      this.gallerySwiper.slides.forEach((slide) => {
        if (slide == activeSlide) {
          activeSlide.removeAttribute("aria-hidden");
          activeSlide.querySelectorAll("a, button").forEach((el) => {
            el.tabIndex = null;
          });
        } else {
          slide.setAttribute("aria-hidden", "true");
          slide.querySelectorAll("a, button").forEach((el) => {
            el.tabIndex = -1;
          });
        }
      });
    };

    let swiperParams = {
      modules: [Pagination],
      slidesPerView: "auto",
      spaceBetween: 60,
      loop: true,
      speed: 400,
      zoom: {
        maxRatio: 1,
      },
      watchSlidesProgress: true,
      centerInsufficientSlides: true,
      breakpoints: {
        1024: {
          spaceBetween: 90,
        },
      },
      navigation: {
        nextEl: this.querySelector("[data-navigation-next]"),
        prevEl: this.querySelector("[data-navigation-previous]"),
      },
    };

    if (this.thumbsSwiper) {
      swiperParams = {
        ...swiperParams,
        thumbs: {
          swiper: this.thumbsSwiper,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },

        navigation: {
          nextEl: this.querySelector("[data-thumb-navigation-next]"),
          prevEl: this.querySelector("[data-thumb-navigation-previous]"),
        },
        on: {
          realIndexChange: () => updateCurrentSlide(),
          // slideChangeTransitionStart: () => {
          //   this.gallerySwiper.slides.forEach((slide) => {
          //     slide.setAttribute("aria-hidden", "true");
          //     slide.querySelectorAll("a, button").forEach((el) => {
          //       el.tabIndex = -1;
          //     });
          //   });
          // },
          // slideChangeTransitionEnd: () => {
          //   const activeSlide =
          //     this.gallerySwiper.slides[this.gallerySwiper.activeIndex];
          //   activeSlide.removeAttribute("aria-hidden");
          //   activeSlide.querySelectorAll("a, button").forEach((el) => {
          //     el.tabIndex = null;
          //   });
          // },
        },
      };
    }

    this.gallerySwiper = new Swiper(
      this.querySelector(`.${this._prefix}__media-container`),
      swiperParams,
    );

    updateCurrentSlide();

    this.gallerySwiper.on("slideChange", () => {
      this.dispatchEvent(
        new CustomEvent("cylindo-trigger", {
          bubbles: true,
          detail: { action: null },
        }),
      );

      const visibleSlides = this.gallerySwiper.slides.filter((slide) =>
        slide.classList.contains("swiper-slide-visible"),
      );
      this._selectVideo(visibleSlides);
    });

    this.gallerySwiper.on("click", (_, e) => {
      if (e.target.closest("[data-video-control-button]")) return;

      this._openZoomGallery(this.querySelector("a, button"));
    });
  }

  _openZoomGallery(trigger) {
    const zoomGallery = this._zoomMarkup?.content.children[0];

    if (!zoomGallery) return;

    zoomGallery.dataset.preselectMediaIndex =
      this.gallerySwiper?.realIndex || 0;

    const html = zoomGallery.outerHTML;
    (trigger || this).dispatchEvent(
      new CustomEvent("markup-modal:open", {
        bubbles: true,
        detail: { html, target: "zoom-modal" },
      }),
    );
  }

  _destroyCarousel() {
    if (!this.gallerySwiper) return;

    this.gallerySwiper.destroy(true, true);
    this.gallerySwiper = null;
    this._toggleSwiperClasses(false);
  }

  _toggleSwiperClasses(add) {
    this.querySelectorAll("[data-swiper-class]").forEach((el) => {
      el.classList.toggle(el.dataset.swiperClass, add);
    });
  }

  _selectVideo(els) {
    this.activeVideos.forEach((video) => video.pause());

    this.activeVideos = [];

    els.forEach((el) => {
      const video = el.querySelector("video");

      if (video) {
        this.activeVideos.push(video);
        video.play();
      }
    });
  }

  get _zoomMarkup() {
    return this.querySelector("[data-zoom-markup]");
  }

  get _prefix() {
    return this.dataset.classPrefix;
  }

  get _isMobile() {
    return window.matchMedia("(max-width: 1023px)").matches;
  }
}

if (!customElements.get("media-gallery")) {
  customElements.define("media-gallery", MediaGallery);
}
